import { Dot } from '../Domain/Dot'

class CElement {
  static KIND = {
    TEXT : 'text',
    IMAGE : 'image',
    SEPARATOR : 'separator'
  }

  constructor(kind) {
    this.kind = kind
  }
  
  static with(dot) {
    if (dot === null) {
      return new CSeparatorElement(CElement.KIND.SEPARATOR)
    }

    switch (dot.dotType) {
      case Dot.TYPE.TEXT:
      return new CTextElement(dot, CElement.KIND.TEXT)
      case Dot.TYPE.IMAGE:
      return new CImageElement(dot, CElement.KIND.IMAGE)
      default:
      break
    }
  }
}

class CContentElement extends CElement {
  constructor(dot, kind) {
    super(kind)
    this.dot = dot
  }
}

class CTextElement extends CContentElement {
  text(handler) {
    this.dot.text(handler)
  }
}

class CImageElement extends CContentElement {
  imageUrl() {
    return this.dot.imageUrl()
  }
}

class CSeparatorElement extends CElement {
  
}

export default CElement
export { CTextElement, CImageElement, CSeparatorElement }


// WEBPACK FOOTER //
// ./src/App/CElement.js